<template>
  <div class="row no-gutters patient-history">
    <div class="col-12" v-if="current">
      <div class="head py-2 px-3 row no-gutters bg-primary">
        <div class="col-auto first">
          <a class="pointer" @click.prevent="first" v-if="index !== 0">
            <double-arrow-icon></double-arrow-icon>
          </a>
        </div>
        <div class="col-auto prev">
          <a class="pointer" @click.prevent="prev" v-if="index !== 0">
            <angle-icon></angle-icon>
          </a>
        </div>
        <div class="col text-center">
          <template v-if="current">
            <strong>
              {{ current.schedule.clinic_service.name[authLocale] }}
            </strong>
            <small>{{ current.start_time | moment('ddd, DD MMMM') }}</small>
          </template>
        </div>
        <div class="col-auto next">
          <a
            class="pointer"
            @click.prevent="next"
            v-if="index !== panelItems.length - 1"
          >
            <angle-icon></angle-icon>
          </a>
        </div>
      </div>
      <div class="body" v-if="current">
        <PatientCaseEdit v-if="current.status === 'active'" :value="current.id"></PatientCaseEdit>
        <PatientCase v-else :value="current.id"></PatientCase>
      </div>
      <!-- {{item}} -->
      <!-- <schedule :key="item.id" :value="item.id"></schedule> -->
    </div>
    <!-- <div class="col-12" v-if="cases && cases.length > 0">
        <template v-for="c of cases">
          <patient-case :key="c.id" :value="c"></patient-case>
        </template>
      </div> -->
  </div>
</template>
<script>
import AngleIcon from '@/components/Icons/Angle'
import DoubleArrowIcon from '@/components/Icons/DoubleArrow'
import PatientCase from '@/components/Cases/PatientCase'
import PatientCaseEdit from '@/components/Cases/PatientCaseEdit'
import { mapGetters, mapMutations } from 'vuex'
import Fetch from '@/mixins/Fetch'
export default {
  mixins: [Fetch],
  components: {
    AngleIcon,
    DoubleArrowIcon,
    PatientCase,
    PatientCaseEdit
  },
  props: {
    patient: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      index: 0
    }
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user',
      schedules: 'schedule/schedulesAscNotCancelled',
      scheduleById: 'schedule/byId',
      cases: 'pcase/cases',
      activeCases: 'pcase/active',
      panelItems: 'panel/items'
    }),
    current () {
      return this.cases[this.index]
    }
  },
  mounted () {
    this.resetPanel()
    this.setpatient_id(this.patient.id)
    this.setdoctor_id(this.authUser.id)
    this.fetchCases(this.patient.id)
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError',
      setCase: 'pcase/set',
      resetCases: 'pcase/reset',
      setCaseId: 'schedule/setCaseId',
      pushPanel: 'panel/push',
      resetPanel: 'panel/reset',
      setpatient_id: 'panel/setpatient_id',
      setdoctor_id: 'panel/setdoctor_id'
    }),
    next () {
      if (this.panelItems.length - 1 === this.index) {
        return
      }
      this.index += 1
    },
    prev () {
      if (this.index === 0) {
        return
      }
      this.index -= 1
    },
    first () {
      this.index = 0
    },
    async fetchCases (patient_id) {
      try {
        const params = {
          offset: 0,
          limit: 20,
          patient_id: patient_id,
          category_ids: '',
          statuses: []
        }
        const response = await this.axios.get('/api/patient-cases', { params })
        for (const c of response.data.data) {
          this.setCase(c)
          this.pushPanel({
            id: c.id,
            title: this.$moment(c.start_time).format('DD MMMM YYYY'),
            component:
              c.status === 'active' ? 'patient-case-edit' : 'patient-case',
            date: c.start_time
          })
        }
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.patient-history {
  .head {
    // background: #3c88ff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    position: sticky;
    top: 0;
    z-index: 140;
    color: #fff;
    .first {
      transform: rotate(180deg);
      svg {
        width: 24px;
        height: 24px;
      }
    }
    .prev {
      transform: rotate(90deg);
      svg {
        width: 24px;
        height: 24px;
      }
    }
    .next {
      transform: rotate(-90deg);
      svg {
        width: 24px;
        height: 24px;
      }
    }
  }
}
</style>
